import { render, staticRenderFns } from "./my_subscribe.vue?vue&type=template&id=287b8b79&scoped=true"
import script from "./my_subscribe.vue?vue&type=script&lang=js"
export * from "./my_subscribe.vue?vue&type=script&lang=js"
import style0 from "./my_subscribe.vue?vue&type=style&index=0&id=287b8b79&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287b8b79",
  null
  
)

export default component.exports